var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrenada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#be2a2c",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6d44a",
    d: "M5 5h20v14H5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#357960",
    d: "m5 5 10 7-10 7zm20 0-10 7 10 7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#be2a2c",
    d: "M15 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6d44a",
    d: "m16 12.34 1.62-1.18h-2L15 9.26l-.62 1.9h-2L14 12.34l-.62 1.9L15 13.06l1.62 1.18zm-.46-9.15.88-.64h-1.08L15 1.5l-.34 1.04h-1.08l.88.64-.34 1.03.88-.64.88.64zm-4.84 0 .88-.64h-1.09l-.33-1.04-.34 1.04H8.73l.88.64-.33 1.03.88-.64.88.64zm8.6 0-.88-.64h1.09l.33-1.04.34 1.04h1.09l-.88.64.33 1.03-.88-.64-.87.64zm-3.76 18.05.88-.64h-1.08L15 19.56l-.34 1.04h-1.08l.88.63-.34 1.04.88-.64.88.64zm-4.84 0 .88-.64h-1.09l-.33-1.04-.34 1.04H8.73l.88.63-.33 1.04.88-.64.88.64zm8.6 0-.88-.64h1.09l.33-1.04.34 1.04h1.09l-.88.63.33 1.04-.88-.64-.87.64z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#be2a2c",
    d: "M7.07 12.13a4 4 0 0 0 1.61 1.7 6 6 0 0 0-.5-2.26z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6d44a",
    d: "M6.45 9.85c.51 1.1-1.4 3.65 1.71 4.3a3.2 3.2 0 0 1-.48-2.1c.65.27 1.3.9 1.55 1.5 1.07-2.98-2.1-2.7-2.78-3.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrenada);
export default __webpack_public_path__ + "static/media/grenada.3a9d82830af1a09720dfde4d0e05243d.svg";
export { ForwardRef as ReactComponent };